import React from "react";
import {
  POSTHOG_PAYLOAD_FLAGS,
  useFeatureFlagPayload,
} from "utils/posthogFeatureFlags";

interface InfoBannerPayload {
  enabled: boolean;
  bannerConfig: BannerConfig;
}

interface BannerConfig {
  message: string;
  containerDiv: string;
  textDiv: string;
}

export const InfoBanner: React.FC<{ className?: string }> = ({ className }) => {
  const flagPayload = useFeatureFlagPayload<InfoBannerPayload>(
    POSTHOG_PAYLOAD_FLAGS.INFO_BANNER,
  );

  const bannerConfig =
    flagPayload && typeof flagPayload === "object" && flagPayload.enabled
      ? flagPayload.bannerConfig
      : null;

  if (!bannerConfig) {
    return null;
  }

  return (
    <div
      className={`w-full max-w-7xl mx-auto sm:px-6 lg:px-8 py-2 ${
        className ?? ""
      }`}
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <div
          className={`flex flex-row items-center justify-start border rounded-lg p-2 ${bannerConfig?.containerDiv}`}
        >
          <div className="flex flex-row items-center w-full">
            <div className="flex flex-row justify-center w-full">
              <div
                className={`flex flex-row items-center gap-1 text-sm justify-center ${bannerConfig?.textDiv}`}
              >
                {bannerConfig?.message}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoBanner;
